import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { FC } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller } from 'react-hook-form';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useTradingFormContext } from './trading-form-context';
import { FormContainer } from '../../foundation/layout/form-container';
import { FieldWrapper } from '../../foundation/layout/field-wrapper';

type TradingScheduleFormProps = {};

export const TradingScheduleForm: FC<TradingScheduleFormProps> = () => {
  const { control, setValue, watch } = useTradingFormContext();
  const { trade } = watch('tradingScheduleConfig') || {};

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormContainer>
        {/* Trade */}
        <FieldWrapper>
          <FormControlLabel
            control={
              <Controller
                name="tradingScheduleConfig.trade"
                control={control}
                render={({ field }) => (
                  <Checkbox {...field} checked={!!trade} />
                )}
              />
            }
            label="Trade"
          />
        </FieldWrapper>

        {/* Trading Window Start */}
        <FieldWrapper>
          <Controller
            name="tradingScheduleConfig.tradingWindowStart"
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                value={field.value ? dayjs(field.value) : null}
                label="Trading Window Start"
                format="DD/MM/YYYY"
                onChange={(date) => {
                  const isoDate = date ? date.toISOString() : undefined;
                  setValue('tradingScheduleConfig.tradingWindowStart', isoDate);
                }}
              />
            )}
          />
        </FieldWrapper>

        {/* Trading Window End */}
        <FieldWrapper>
          <Controller
            name="tradingScheduleConfig.tradingWindowEnd"
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                value={field.value ? dayjs(field.value) : null}
                label="Trading Window End"
                format="DD/MM/YYYY"
                onChange={(date) => {
                  const isoDate = date ? date.toISOString() : undefined;
                  setValue('tradingScheduleConfig.tradingWindowEnd', isoDate);
                }}
              />
            )}
          />
        </FieldWrapper>
      </FormContainer>
    </LocalizationProvider>
  );
};
